import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { isAdvertorial } from '../advertorial/advertorial';
import { figureOutPriorityTag } from '../../../utils/ad_util';

function showLive(live) {
  if (live) {
    return (
      <li className="eyebrow__item eyebrow__item--live">
        <span className="eyebrow__live">Live</span>
      </li>
    );
  }

  return null;
}

function getText(tags) {
  const eyeBrowText = figureOutPriorityTag(tags);
  const { slug } = eyeBrowText;
  let { name } = eyeBrowText;

  if (!slug || !name) {
    return null;
  }

  name = name
    .replace(/\*/g, '')
    .replace(/_/g, ' ')
    .replace(/\s?advertorial/g, '')
    .trim();

  if (name === 'LOreal') {
    name = "L'Oreal";
  }

  if (name === 'ATT') {
    name = 'AT&T';
  }

  let link = `/section/${slug}`;

  if (link === '/section/most-creative-people') {
    link = '/most-creative-people';
  }

  return { name, link };
}

function renderTag(tags) {
  const data = getText(tags);

  if (data) {
    const { name, link } = data;

    return (
      <li className="eyebrow__item">
        {isAdvertorial(tags) ? name : <Link to={link}>{name}</Link>}
      </li>
    );
  }
  return null;
}

function shouldShowTime(post) {
  const showTime = get(post, 'showTime');
  if (!showTime) return null;
  return <li className="eyebrow__item">{get(post, 'timePublished')} </li>;
}

export default function Eyebrow(props) {
  if (!props) {
    return null;
  }

  const { metadata, post, tags, modifier, live, insert } = props;

  if (!isEmpty(metadata)) {
    const cardTags = metadata.tags || [];
    let category = get(metadata, 'categories[0].name');

    // Handles coDesign posts category, if there's a tag that matches older legacy categories, use that instead
    if (category === 'Co.Design' && get(metadata, 'categories[1].name')) {
      category = get(metadata, 'categories[1].name');
    }

    let eyebrow = category || null;

    if (!eyebrow && metadata.dateFormatted && metadata.timePublished) {
      eyebrow = `${metadata.dateFormatted} | ${metadata.timePublished}`;
    }

    if (isAdvertorial(cardTags)) {
      const data = getText(cardTags);
      if (data) {
        const { name } = data;
        eyebrow = `Presented By ${name}`;
      }
    }

    if (get(metadata, 'isSponsoredTile')) {
      eyebrow = '';
    }

    // When it's a News story, it has category Uncategorized
    // we don't want to show that to the user, use date instead
    if (eyebrow === 'Uncategorized') {
      eyebrow = metadata.timePublished;
    }

    if (metadata.customEyebrowText) {
      if (metadata.fullyReplaceEyebrow) {
        eyebrow = metadata.customEyebrowText;
      } else {
        eyebrow = isAdvertorial(cardTags)
          ? `Sponsored: ${metadata.customEyebrowText}`
          : metadata.customEyebrowText;
      }
    }

    return (
      eyebrow && (
        <span className={`eyebrow eyebrow--${modifier}`}>{eyebrow}</span>
      )
    );
  }

  if (!isEmpty(post)) {
    let finalDate = get(post, 'dateFormatted');
    const dateStandardUS = finalDate.replace(/\./g, '-');
    finalDate = dateStandardUS;

    return (
      <ul className={insert ? 'eyebrow article__preview__eyebrow' : 'eyebrow'}>
        {showLive(live)}
        <li
          className={
            insert
              ? 'eyebrow__item article__preview__eyebrow__item'
              : 'eyebrow__item'
          }
        >
          <time dateTime={get(post, 'structuredData.published')}>
            {finalDate}
          </time>
        </li>
        {shouldShowTime(post)}
        {renderTag(tags)}
      </ul>
    );
  }

  return null;
}

Eyebrow.defaultProps = {
  post: {},
  metadata: {},
  modifier: '',
  live: false,
  insert: false
};

Eyebrow.propTypes = {
  post: PropTypes.shape({}),
  // eslint-disable-next-line react/require-default-props
  tags: PropTypes.arrayOf(PropTypes.shape({})),
  metadata: PropTypes.shape({}),
  modifier: PropTypes.string,
  live: PropTypes.bool,
  insert: PropTypes.bool
};
